import React from 'react';

import LoginForm from './LoginForm';

export default function AthleteLogin() {
  return <LoginForm isAthlete />;
}
